/* -----------------Globals--------------- */
import { ScrollView } from "react-native";

import { useAppTheme } from "@hooks/useAppTheme";
/* -----------------Child components--------------- */
import CustomChip from "@memorang/ui/src/components/CustomChip";
import pluralize from "pluralize";
import { useTranslation } from "react-i18next";

type Props = {
	handleClickActionChip: (type: string) => void;
	showReview?: boolean;
	showStudy?: boolean;
	isPremiumUser?: boolean;
	tagTypeLabel?: string;
};
export const SuggestedActionsChips = ({
	handleClickActionChip,
	showReview,
	showStudy,
	isPremiumUser,
	tagTypeLabel,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const actionsChips = [
		...(showStudy
			? [
					{
						label: isPremiumUser
							? t("report.actions.studyMore")
							: `Study free ${pluralize(tagTypeLabel || "topics")}`,
						type: "study",
						icon: "book-open-page-variant",
					},
				]
			: []),
		...(showReview
			? [
					{
						label: "Review answers",
						type: "review",
						icon: "check-all",
					},
				]
			: []),
	];

	if (!actionsChips.length) {
		return null;
	}
	return (
		<ScrollView
			horizontal
			contentContainerStyle={{
				gap: 8,
				flex: 1,
			}}
		>
			{actionsChips.map(({ label, type, icon }) => {
				return (
					<CustomChip
						mode="outlined"
						key={type}
						icon={icon}
						iconColor={theme.colors.primary}
						onPress={() => handleClickActionChip(type)}
					>
						{label}
					</CustomChip>
				);
			})}
		</ScrollView>
	);
};
